export default "__VITE_ASSET__tZtW0Ii0__"